export default __webpack_public_path__ + "assembly8b22973.png";